module.exports = __webpack_public_path__ + "img/menu-bar-on_05.35c13f72.png";